export const addYears = {
  methods: {
    addYears(date, years) {
      const tempDate = date.getDate();
      const tempMonth = date.getMonth();
      date.setFullYear(date.getFullYear() + +years);
      if (date.getDate() !== tempDate) {
        date.setDate(0)
      }
      if (date.getMonth() !== tempMonth) {
        date.setMonth(0)
      }
      return date
    }
  }
};